var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5473E9",
    fillRule: "evenodd",
    d: "M13.784 0l.153.006C15.092.092 16 1.158 16 2.46v10.336h-1.481V2.461c0-.453-.332-.82-.741-.82s-.741.367-.741.82V21H0V2.46C0 1.102.994 0 2.221 0h11.563zm-2.102 1.64h-9.46c-.41 0-.74.367-.74.82v16.9h10.074V2.46c0-.287.044-.563.126-.82zm-1.608 14.602v1.64H2.963v-1.64h7.111zm0-3.281v1.64H2.963v-1.64h7.111zm0-3.282v1.64H2.963V9.68h7.111zm0-3.28v1.64H2.963v-1.64h7.111z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.af3528391b03f4dfeececf1d8cc2e69e.svg";
export { ForwardRef as ReactComponent };